import jwtDecode from "jwt-decode";

/**
 * Toma el token de impersonación de la URL (`?impersonationToken=…`) y lo instala
 * como token de sesión ANTES de que arranque la app.
 *
 * Debe importarse como PRIMER import en index.js: los reducers de sesión y de
 * usuario leen `localStorage.getItem("token")` en tiempo de import (via
 * configureStore) y lo decodifican sin try/catch. Si el token no está puesto
 * para entonces, el usuario impersonado no queda logueado; si está mal formado,
 * la app crashea al iniciar.
 *
 * El backoffice arma esa URL después de que api-core (o la firma local) emite el
 * JWT. Acá sólo lo movemos de la query string a localStorage y limpiamos la URL.
 */
function installImpersonationToken() {
  if (typeof window === "undefined") return;

  let params;
  try {
    params = new URLSearchParams(window.location.search);
  } catch (error) {
    return;
  }

  const impersonationToken = params.get("impersonationToken");
  if (!impersonationToken) return;

  // Validamos que sea un JWT real antes de guardarlo: los reducers lo van a
  // jwtDecode sin protección, así que un token basura tiraría abajo el boot.
  try {
    jwtDecode(impersonationToken);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("impersonationToken inválido, se ignora", error);
    return;
  }

  // Empezamos de cero: descartamos cualquier company seleccionada de una sesión
  // previa en este navegador para que el impersonado caiga en la suya.
  localStorage.removeItem("selected_company_id");
  localStorage.setItem("token", impersonationToken);

  // Sacamos el token de la URL: que no quede en el historial, en el header
  // Referer hacia terceros ni en los access logs.
  params.delete("impersonationToken");
  const query = params.toString();
  const cleanUrl =
    window.location.pathname +
    (query ? `?${query}` : "") +
    window.location.hash;
  window.history.replaceState({}, document.title, cleanUrl);
}

installImpersonationToken();
